import React, { useEffect, useState } from "react";

import Seta from "../../../../Assets/images/seta.png";

import {
	Document,
	Font,
	Image,
	Page,
	StyleSheet,
	Text,
	View,
} from "@react-pdf/renderer";

import Roboto from "../../../../Assets/fonts/Roboto-Bold.ttf";
import { VendaService } from "../../../../service/venda_service";

Font.register({
	family: "Roboto bold",
	format: "truetype",
	src: Roboto,
});

const styles = StyleSheet.create({
	page: {
	},
	body: {
		paddingTop: "5px",
		paddingLeft: "5px",
		paddingRight: "5px",
		width: "100%",
		height: "100%",
		backgroundColor: "white",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	topEtiquetaContainer: {
		width: "100%",
		height: "40px",
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		flexDirection: "row",
		padding: "0",
		margin: "0",
	},
	logoEmpressaContainer: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		height: "30px",
		width: "70px",
	},
	codBarContainer: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	bottonEtiquetaContainer: {
		width: "100%",
		height: "100%",
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		flexDirection: "row",
	},
	bottonRightTextEtiquetaContainer: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		flexDirection: "row",
	},
	containerQrcode: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	qrCode: {
		width: "40px",
	},
	qrCodeContainer: {
		width: "100%",
		height: "100%",
		display: "flex",
		flexDirection: "column",
		justifyContent: "space-between",
		alignItems: "center",
		color: "black",
	},
	qrCodeContainerTexTitle: {
		fontSize: "84px",
		textTransform: "uppercase",
		fontFamily: "Roboto bold",
	},
	qrCodeContainerTextSubTitle: {
		fontSize: "30px",
	},
	footer: {
		position: "absolute",
		width: "100vw",
		height: "13px",
		bottom: 0,
	},

	containerFooter: {
		width: "100vw",
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center",
	},
	paggingContainer: {
		width: "100%",
		backgroundColor: "black",
		height: "10px",
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-evenly",
		alignItems: "center",
	},
	paggingText: {
		alignItems: "flex-end",
		fontSize: "8px",
		paddingHorizontal: "5px",
		fontFamily: "Roboto bold",
		color: "white",
	},
	imgFooterInvetida: {
		height: "100%",
		width: "auto",
		transform: "scaleX(-1)",
	},
	imgFooter: {
		height: "100%",
		width: "auto",
	},
	// textTransform
	TextBoldTitle: {
		fontFamily: "Roboto bold",
		fontSize: "10px",
	},
	TextBoldTitleSmall: {
		fontFamily: "Roboto bold",
		fontSize: "8px",
	},
	TextBoldTitleRight: {
		fontFamily: "Roboto bold",
		fontSize: "12px",
	},
	TextBoldTitleNumber: {
		fontFamily: "Roboto bold",
		fontSize: "16px",
	},
	TextBoldSubTitle: {
		fontFamily: "Roboto bold",
		fontSize: "7px",
	},
	TextBold: {
		fontFamily: "Roboto bold",
		fontSize: "6px",
	},
	TextNormal: {
		fontSize: "6px",
	},
	TextNormalQrCode: {
		fontSize: "4px",
	},
});

const PdfHangTags16x5 = (props) => {
	const logo = props.logo;

	const vendaItemId = props.item;
	const vendaId = props.venda;
	const [loading, setLoading] = useState(true);
	const [venda, setVenda] = useState(null);
	const [vendaItem, setVendaItem] = useState(null);

	const vendaService = new VendaService();

	useEffect(() => {
		initData();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const formatCpfCnPJ = (value) => {
		if (value.length > 11) {
			value =
				value.substring(0,2) +
				"." +
				value.substring(2, 5) +
				"." +
				value.substring(5, 8) +
				"/" +
				value.substring(8, 12) +
				"." +
				value.substring(12);
		} else {
			value =
				value.substring(0,3) +
				"." +
				value.substring(3,6) +
				"." +
				value.substring(6,9) +
				"-" +
				value.substring(9);
		}
		return value;
	};

	const getNomeProduto = (vendaItem) => {
		if (!vendaItem) return "Produto não informado";
		const cultura = vendaItem?.ordemProducao?.produtoFinal?.cultivo?.cultura || "";
		const variedade = vendaItem?.ordemProducao?.produtoFinal?.cultivo?.variedade || "";
		return cultura && variedade
			? `${cultura} ${variedade}`
			: cultura || variedade || "Produto não informado";
	};

	const initData = async () => {
		try {
			if (!vendaId || !vendaItemId) {
				setLoading(false);
				return;
			}

			const vendaData = await vendaService.getById(vendaId);
			if (!vendaData) {
				setLoading(false);
				return;
			}

			setVenda(vendaData);

			const item = vendaData.itens?.find((i) => i.ordemProducaoId === vendaItemId);
			setVendaItem(item);

			setLoading(false);
		} catch (error) {
			console.error("Erro ao carregar dados da venda:", error);
			setLoading(false);
		}
	};


	function checkValid() {
		return props.checkDist === "0" ? true : false;
	}

	//qrcode
	const ids = props.ids;
	function QRCodePage({ id }) {
		const dataUrl = document.getElementById(id).toDataURL();
		return <Image src={dataUrl} style={styles.qrCode} />;
	}

	function checkDoubleTag() {
		return props.doubleTag === "0" ? true : false;
	}

	return (
		!loading ?
			<Document>
				<Page size={{ width: 453.39, height: checkDoubleTag() ? 303.32 : 141.66 }} style={styles.page}>
					<View style={{height: 141.66}}>
						<View style={styles.body}>
							<View style={styles.qrCodeContainer}>
								{/* top etiqueta */}
								<View style={styles.topEtiquetaContainer}>
									<View style={{ height: "100%" }}>
										<View style={styles.logoEmpressaContainer}>
											{logo &&
												<Image style={styles.logo} src={logo} />}
										</View>
									</View>
									<View style={styles.codBarContainer}>
										<Text style={{ fontSize: "12px", textTransform: "uppercase" }}>
											{getNomeProduto(vendaItem)}
										</Text>
									</View>
									<View
										style={{
											display: "flex",
											justifyContent: "center",
											alignContent: "center",
											alignItems: "center",
										}}
									>
										{ids.map((id) => (
											<QRCodePage id={id} key={id} />
										))}
									</View>
								</View>
								{/* botton etiqueta */}
								<View style={styles.bottonEtiquetaContainer}>
									{/* esquerda */}
									<View>
										<Text style={checkValid() && props.showExpiryDate ? styles.TextBoldTitleSmall : styles.TextBoldTitle}>
											Código de Rastreio: {`${venda?.numeroVenda}-${vendaItem?.ordemProducao?.loteRastreabilidade}`}
										</Text>
										<Text style={checkValid() && props.showExpiryDate ? styles.TextBoldTitleSmall : styles.TextBoldTitle}>
											Distribuído por {venda?.unidadeDistribuidora?.nome || "Não informado"}{" "}
											{venda?.unidadeDistribuidora?.cpf_cnpj ?
												(venda.unidadeDistribuidora.cpf_cnpj.length > 11
													? `CNPJ: ${formatCpfCnPJ(venda.unidadeDistribuidora.cpf_cnpj)}`
													: `CPF: ${formatCpfCnPJ(venda.unidadeDistribuidora.cpf_cnpj)}`)
												: ""}
										</Text>
										<Text style={checkValid() && props.showExpiryDate ? styles.TextBoldTitleSmall : styles.TextBoldTitle}>
											{venda?.unidadeDistribuidora?.endereco ?
										[(venda.unidadeDistribuidora.endereco.logradouro || venda.unidadeDistribuidora.endereco.endereco), venda.unidadeDistribuidora.endereco.bairro, [venda.unidadeDistribuidora.endereco.cidade, venda.unidadeDistribuidora.endereco.uf].filter(Boolean).join(" - ")].filter(Boolean).join(", ")
										: ""}
										</Text>

										{checkValid() && (
											<>
												<Text style={props.showExpiryDate ? styles.TextBoldTitleSmall : styles.TextBoldTitle}>
													Destino {venda?.cliente?.nome || venda?.cliente?.nomeFantasia}{" "}
													{venda?.cliente?.cpfCnpj && (venda.cliente.cpfCnpj.length > 11
															? `CNPJ: ${formatCpfCnPJ(venda?.cliente?.cpfCnpj)}`
															: `CPF: ${formatCpfCnPJ(venda?.cliente?.cpfCnpj)}`)}
												</Text>
												<Text style={props.showExpiryDate ? styles.TextBoldTitleSmall : styles.TextBoldTitle}>
													{venda?.cliente?.endereco ? [(venda.cliente.endereco.logradouro || venda.cliente.endereco.endereco), venda.cliente.endereco.bairro, [venda.cliente.endereco.cidade, venda.cliente.endereco.uf].filter(Boolean).join(" - ")].filter(Boolean).join(", ") : ""}
												</Text>
											</>
										)}
										{(vendaItem?.ordemProducao?.dataValidade && props.showExpiryDate) ? (
											<>
												<Text style={checkValid() ? styles.TextBoldTitleSmall : {...styles.TextBoldTitle, fontSize: "9px"}}>
													{vendaItem?.ordemProducao?.dataProducao &&
														`Data de Embalagem: ${new Date(vendaItem?.ordemProducao?.dataProducao).toLocaleDateString("pt-BR")} - `}
													Data de Entrega: {new Date(venda?.dataExpedicao).toLocaleDateString("pt-BR")}
												</Text>
												<Text style={checkValid() ? styles.TextBoldTitleSmall : {...styles.TextBoldTitle, fontSize: "9px"}}>
													Data de Validade: {new Date(vendaItem?.ordemProducao?.dataValidade).toLocaleDateString("pt-BR")}
												</Text>
											</>
										) : (
											<Text style={checkValid() && props.showExpiryDate ? styles.TextBoldTitleSmall : styles.TextBoldTitle}>
												{vendaItem?.ordemProducao?.dataProducao &&
													`Data de Embalagem: ${new Date(vendaItem?.ordemProducao?.dataProducao).toLocaleDateString("pt-BR")} - `}
												Data de Entrega: {new Date(venda?.dataExpedicao).toLocaleDateString("pt-BR")}
											</Text>
										)}
										<Text style={checkValid() && props.showExpiryDate ? styles.TextBoldTitleSmall : styles.TextBoldTitle}>{vendaItem?.especificacao}</Text>
									</View>
									{/* direita */}
									<View>
										<View style={styles.bottonRightTextEtiquetaContainer}>
											<Text style={styles.TextBoldTitleRight}>Peso liq. </Text>
											<Text style={styles.TextBoldTitleNumber}>{`${vendaItem?.ordemProducao?.embalagemProdutoFinal?.quantidade} ${vendaItem?.ordemProducao?.embalagemProdutoFinal?.unidadeMedida?.sigla}`}</Text>
										</View>
									</View>
								</View>
							</View>
						</View>
						{/* roda pé  */}
						<View style={styles.footer} fixed>
							<View style={styles.paggingContainer}>
								<Image src={Seta} style={styles.imgFooter} />
								<View style={styles.paggingText}>
									<Text>PRODUTO COM ORIGEM RASTREADA</Text>
								</View>
								<Image src={Seta} style={styles.imgFooterInvetida} />
								<View style={styles.paggingText}>
									<Text>https://www.sisagri.com.br</Text>
								</View>
								<Image src={Seta} style={styles.imgFooterInvetida} />
							</View>
						</View>
					</View>
					{checkDoubleTag() && (
						<>
							<View style={{height: 19.8, backgroundColor: "transparent"}} />
							<View style={{height: 141.66}}>
								<View style={styles.body}>
									<View style={styles.qrCodeContainer}>
										{/* top etiqueta */}
										<View style={styles.topEtiquetaContainer}>
											<View style={{ height: "100%" }}>
												<View style={styles.logoEmpressaContainer}>
													{logo &&
														<Image style={styles.logo} src={logo} />}
												</View>
											</View>

											<View style={styles.codBarContainer}>
												<Text style={{ fontSize: "12px", textTransform: "uppercase" }}>
													{getNomeProduto(vendaItem)}
												</Text>
											</View>
											<View
												style={{
													display: "flex",
													justifyContent: "center",
													alignContent: "center",
													alignItems: "center",
												}}
											>
												{ids.map((id) => (
													<QRCodePage id={id} key={id} />
												))}
											</View>
										</View>
										{/* botton etiqueta */}
										<View style={styles.bottonEtiquetaContainer}>
											{/* esquerda */}
											<View>
												<Text style={checkValid() && props.showExpiryDate ? styles.TextBoldTitleSmall : styles.TextBoldTitle}>
													Código de Rastreio: {`${venda?.numeroVenda}-${vendaItem?.ordemProducao?.loteRastreabilidade}`}
												</Text>
												<Text style={checkValid() && props.showExpiryDate ? styles.TextBoldTitleSmall : styles.TextBoldTitle}>
													Distribuído por {venda?.unidadeDistribuidora?.nome || "Não informado"}{" "}
													{venda?.unidadeDistribuidora?.cpf_cnpj ?
														(venda.unidadeDistribuidora.cpf_cnpj.length > 11
															? `CNPJ: ${formatCpfCnPJ(venda.unidadeDistribuidora.cpf_cnpj)}`
															: `CPF: ${formatCpfCnPJ(venda.unidadeDistribuidora.cpf_cnpj)}`)
														: ""}
												</Text>
												<Text style={checkValid() && props.showExpiryDate ? styles.TextBoldTitleSmall : styles.TextBoldTitle}>
													{venda?.unidadeDistribuidora?.endereco ?
										[(venda.unidadeDistribuidora.endereco.logradouro || venda.unidadeDistribuidora.endereco.endereco), venda.unidadeDistribuidora.endereco.bairro, [venda.unidadeDistribuidora.endereco.cidade, venda.unidadeDistribuidora.endereco.uf].filter(Boolean).join(" - ")].filter(Boolean).join(", ")
										: ""}
												</Text>

												{checkValid() && (
													<>
														<Text style={props.showExpiryDate ? styles.TextBoldTitleSmall : styles.TextBoldTitle}>
															Destino {venda?.cliente?.nome || venda?.cliente?.nomeFantasia}{" "}
															{venda?.cliente?.cpfCnpj && (venda.cliente.cpfCnpj.length > 11
																	? `CNPJ: ${formatCpfCnPJ(venda?.cliente?.cpfCnpj)}`
																	: `CPF: ${formatCpfCnPJ(venda?.cliente?.cpfCnpj)}`)}
														</Text>
														<Text style={props.showExpiryDate ? styles.TextBoldTitleSmall : styles.TextBoldTitle}>
															{venda?.cliente?.endereco ? [(venda.cliente.endereco.logradouro || venda.cliente.endereco.endereco), venda.cliente.endereco.bairro, [venda.cliente.endereco.cidade, venda.cliente.endereco.uf].filter(Boolean).join(" - ")].filter(Boolean).join(", ") : ""}
														</Text>
													</>
												)}
												{(vendaItem?.ordemProducao?.dataValidade && props.showExpiryDate) ? (
													<>
														<Text style={checkValid() ? styles.TextBoldTitleSmall : {...styles.TextBoldTitle, fontSize: "9px"}}>
															{vendaItem?.ordemProducao?.dataProducao &&
																`Data de Embalagem: ${new Date(vendaItem?.ordemProducao?.dataProducao).toLocaleDateString("pt-BR")} - `}
															Data de Entrega: {new Date(venda?.dataExpedicao).toLocaleDateString("pt-BR")}
														</Text>
														<Text style={checkValid() ? styles.TextBoldTitleSmall : {...styles.TextBoldTitle, fontSize: "9px"}}>
															Data de Validade: {new Date(vendaItem?.ordemProducao?.dataValidade).toLocaleDateString("pt-BR")}
														</Text>
													</>
												) : (
													<Text style={checkValid() && props.showExpiryDate ? styles.TextBoldTitleSmall : styles.TextBoldTitle}>
														{vendaItem?.ordemProducao?.dataProducao &&
															`Data de Embalagem: ${new Date(vendaItem?.ordemProducao?.dataProducao).toLocaleDateString("pt-BR")} - `}
														Data de Entrega: {new Date(venda?.dataExpedicao).toLocaleDateString("pt-BR")}
													</Text>
												)}
												<Text style={checkValid() && props.showExpiryDate ? styles.TextBoldTitleSmall : styles.TextBoldTitle}>{vendaItem?.especificacao}</Text>
											</View>
											{/* direita */}
											<View>
												<View style={styles.bottonRightTextEtiquetaContainer}>
													<Text style={styles.TextBoldTitleRight}>Peso liq. </Text>
													<Text style={styles.TextBoldTitleNumber}>{`${vendaItem?.ordemProducao?.embalagemProdutoFinal?.quantidade} ${vendaItem?.ordemProducao?.embalagemProdutoFinal?.unidadeMedida?.sigla}`}</Text>
												</View>
											</View>
										</View>
									</View>
								</View>
								{/* roda pé  */}
								<View style={styles.footer} fixed>
									<View style={styles.paggingContainer}>
										<Image src={Seta} style={styles.imgFooter} />
										<View style={styles.paggingText}>
											<Text>PRODUTO COM ORIGEM RASTREADA</Text>
										</View>
										<Image src={Seta} style={styles.imgFooterInvetida} />
										<View style={styles.paggingText}>
											<Text>https://www.sisagri.com.br</Text>
										</View>
										<Image src={Seta} style={styles.imgFooterInvetida} />
									</View>
								</View>
							</View>
						</>
					)}
				</Page>
			</Document>
			:<Document></Document>
	);
};


export default PdfHangTags16x5;
